/*@ngInject*/
const CollaborationNoteRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.loadCollaborationNote = function (noteId) {
        let url = '/rest/Note/' + noteId;

        return this.get(url);
    };
};

angular.module('gw-um-submission')
    .service('collaborationNoteRepository', CollaborationNoteRepository);
